import { TitleText } from '../orders/_components/common/TitleText';
import { Dialog, DialogTrigger, DialogContent } from '@/components/atoms/Dialog';
import TutorialTriggerButton from '@/components/molecules/TutorialTriggerButton';
import { LayoutTabSection as LayoutTab } from '../orders/_layouts/LayoutTabSection';
import { useMembershipPreviewMode } from '@/components/membership/MembershipContentLock';

export const TabSection = () => {
  return (
    <LayoutTab>
      <div className="flex items-center gap-[16px]">
        <TitleText title="상품 최적화 진단" />
        <TutorialDialog />
      </div>
    </LayoutTab>
  );
};

const TutorialDialog = () => {
  const isPreviewMode = useMembershipPreviewMode();

  return (
    <Dialog>
      <DialogTrigger asChild>
        <TutorialTriggerButton
          data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
        />
      </DialogTrigger>
      <DialogContent
        noCloseBtn
        className="max-w-[430px] p-[30px]"
        data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
      >
        <div className="flex flex-col gap-[20px]">
          <div className="flex flex-col gap-1">
            <div className="text-gr-800 Title3S18">
              스마트스토어 상품 최적화 점수를 한눈에 확인하세요
            </div>
            <div className="whitespace-pre-line text-gr-700 Body5M14">
              {
                '상품명, 카테고리, 태그 등 항목별 진단 결과를\n종합한 최적화 점수를 확인할 수 있어요'
              }
            </div>
          </div>
          <div className="flex flex-col gap-1">
            <div className="text-gr-800 Title3S18">개선 포인트를 바로 확인하고 수정하세요</div>
            <div className="text-gr-700 Body5M14">
              각 항목별 진단 결과를 확인하고 적합/보통/나쁨 상태에 따라 상품을 최적화해 보세요
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
